import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import times from 'lodash/times';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/shine.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/wave2.svg';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
import OfferPastille from '~/components/molecules/Editorial/Offer/OfferPastille.vue';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  name: 'OfferHeader',
  components: {
    GlobalRichText: GlobalRichText,
    OfferPastille: OfferPastille
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      show: false
    };
  },
  computed: {
    currentPayload: function currentPayload() {
      var _this = this;

      var _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13;

      return {
        period: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? (_ref13 = _ref13.period) != null ? (_ref13 = _ref13[0]) != null ? _ref13.text : _ref13 : _ref13 : _ref13 : _ref13) || '',
        title: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? (_ref12 = _ref12.title) != null ? (_ref12 = _ref12[0]) != null ? _ref12.text : _ref12 : _ref12 : _ref12 : _ref12) || '',
        subtitle: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.subtitle : _ref11 : _ref11) || '',
        color_text: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? _ref10.color_text : _ref10 : _ref10) || '',
        background_color: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? _ref9.background_color : _ref9 : _ref9) || '',
        text_before_image: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.text_before_image : _ref8 : _ref8) || '',
        image: {
          small: formatPrismicImage((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? (_ref7 = _ref7.image) != null ? (_ref7 = _ref7.small) != null ? _ref7.url : _ref7 : _ref7 : _ref7 : _ref7, ['w_375,dpr_2']) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? (_ref6 = _ref6.image) != null ? (_ref6 = _ref6.large) != null ? _ref6.url : _ref6 : _ref6 : _ref6 : _ref6, ['w_1440']) || EMPTY_PIXEL
        },
        pastille: times(this.payload.items.length, Number).map(function (i) {
          var _ref3, _ref4, _ref5;

          return {
            price: ((_ref5 = _this.payload) != null ? (_ref5 = _ref5.items) != null ? (_ref5 = _ref5[i]) != null ? _ref5.price : _ref5 : _ref5 : _ref5) || '',
            color: ((_ref4 = _this.payload) != null ? (_ref4 = _ref4.items) != null ? (_ref4 = _ref4[i]) != null ? _ref4.color : _ref4 : _ref4 : _ref4) || '#c4a181',
            text_color: ((_ref3 = _this.payload) != null ? (_ref3 = _ref3.items) != null ? (_ref3 = _ref3[i]) != null ? _ref3.text_color : _ref3 : _ref3 : _ref3) || '#fff'
          };
        })
      };
    },
    headerClass: function headerClass() {
      var _ref, _ref2;

      return !!((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? (_ref2 = _ref2.image) != null ? (_ref2 = _ref2.small) != null ? _ref2.url : _ref2 : _ref2 : _ref2 : _ref2) && !!((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? (_ref = _ref.image) != null ? (_ref = _ref.large) != null ? _ref.url : _ref : _ref : _ref : _ref) ? 'has-background' : 'no-background justify-content-center';
    },
    backgroundColor: function backgroundColor() {
      return this.currentPayload.background_color || '#fff';
    }
  }
};